export { getPageContextPublicClient };
import { getPageContextPublicClientShared } from '../shared/getPageContextPublicClientShared.js';
import '../assertEnvClient.js';
function getPageContextPublicClient(pageContext) {
    return getPageContextPublicClientShared(pageContext);
}
